// .pen: uQr4j (ds/selfie/highlight-card)
import { Star, Target, TrendDown } from '@phosphor-icons/react';

import { cn } from '../../../utils/cn';
import pt from '../../../locales/pt';
import { pickHighlights } from '../../../lib/reportUiUtils';
import { ReportSectionHeading } from './ReportPrimitives';

const CARD_STYLES = {
  good: {
    band: 'bg-sage-tint text-sage-on-tint',
    label: pt.snapshots.report.highlights.best,
    Icon: Star,
  },
  bad: {
    band: 'bg-warning-tint text-warning-fg',
    label: pt.snapshots.report.highlights.attention,
    Icon: TrendDown,
  },
  improve: {
    band: 'bg-muted text-muted-foreground',
    label: pt.snapshots.report.highlights.improve,
    Icon: Target,
  },
};

/**
 * Camada 2 — três destaques digestíveis (melhor · atenção · melhorar).
 */
export function SelfieReportHighlights({ assessment }) {
  const highlights = pickHighlights(assessment);
  if (!highlights.length) return null;

  return (
    <section aria-labelledby="report-highlights-heading">
      <ReportSectionHeading
        id="report-highlights-heading"
        eyebrow={pt.snapshots.report.layers.highlights}
      />
      <div className="mt-space-3 flex flex-col gap-space-3">
        {highlights.map(({ tone, item }) => {
          const style = CARD_STYLES[tone];
          const Icon = style.Icon;
          return (
            <article
              key={`${tone}-${item.title}`}
              className="overflow-hidden rounded-ds-lg border border-border bg-card shadow-sm"
            >
              <div className={cn('flex items-center gap-space-2 px-space-4 py-space-2.5', style.band)}>
                <Icon className="h-4 w-4" aria-hidden />
                <p className="text-type-section font-bold uppercase tracking-[0.06em]">{style.label}</p>
              </div>
              <div className="flex flex-col gap-space-1 p-space-4">
                <p className="text-type-body font-semibold text-foreground">{item.title}</p>
                {item.body ? (
                  <p className="text-type-body-sm leading-relaxed text-muted-foreground">{item.body}</p>
                ) : null}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default SelfieReportHighlights;
